var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-statements */
/* eslint-disable max-lines */
import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, actions as formActions } from 'react-redux-form';
import uuid from 'node-uuid';
import { FormGroup } from "../../Forms";
import { t, Translate } from "../../I18N";
import { getSuggestions } from "../actions/actions";
import Tip from "../../Layout/Tip";
import { propertyTypes } from "../../../shared/propertyTypes";
import { preloadOptionsLimit } from "../../../shared/config";
import { generateID } from "../../../shared/IDGenerator";

import { saveThesaurus } from "../../Thesauri/actions/thesauriActions";
import { sanitizeThesauri } from "../../V2/Routes/Settings/Thesauri/helpers";
import { NeedAuthorization } from "../../Auth";
import {
  DatePicker,
  DateRange,
  Geolocation,
  LinkField,
  MarkDown,
  MultiDate,
  MultiDateRange,
  MultiSelect,
  MultiSuggest,
  Nested,
  Numeric,
  Select,
  LookupMultiSelect,
  MediaField } from "../../ReactReduxForms";

import MultipleEditionFieldWarning from "./MultipleEditionFieldWarning";
import { MediaModalType } from "./MediaModal";
import { MetadataExtractor } from "./MetadataExtractor";
import { DeleteSelectionButton } from "./DeleteSelectionButton";
import { AddThesauriValueButton } from "./AddThesauriValueButton";

const translateOptions = (thesauri) =>
thesauri.
get('values').
map((optionIm) => {
  const option = optionIm.toJS();
  option.label = t(thesauri.get('_id'), option.label, null, false);
  if (option.values) {
    option.options = option.values.map((val) => _objectSpread(_objectSpread({},
    val), {}, {
      label: t(thesauri.get('_id'), val.label, null, false) })
    );
  }
  return option;
}).
toJS();

const groupSameRelationshipFields = (fields) =>
fields.
map((field) => {
  if (field.type !== 'relationship') {
    return field;
  }

  const multiEditingRelationshipFields = fields.filter(
    (f) =>
    f.content === field.content &&
    f.relationType === field.relationType &&
    f._id !== field._id
  );

  if (multiEditingRelationshipFields.length) {
    return _objectSpread(_objectSpread({},
    field), {}, {
      multiEditingRelationshipFields });

  }

  return field;
}).
filter((f) => f);

class MetadataFormFields extends Component {
  async onAddThesauriValueSaved(thesauri, newValue, _model, isMultiSelect) {
    const { model, push, change } = this.props;
    const newThesauri = thesauri.toJS();
    const newValueItem = { label: newValue.value, id: uuid.v4() };
    if (newValue.group === 'root') {
      newThesauri.values.push(newValueItem);
    } else {
      newThesauri.values.forEach((value) => {
        if (value.id === newValue.group) {
          value.values.push(newValueItem);
        }
      });
    }
    const sanitizedThesauri = sanitizeThesauri(newThesauri);
    await this.props.saveThesaurus(sanitizedThesauri);
    const formModel = `${model}${_model}`;
    if (isMultiSelect) {
      push(formModel, newValueItem.id);
    } else {
      change(formModel, newValueItem.id);
    }
  }

  getField(property, _model, thesauris, formModel) {
    let thesauri;
    let totalPossibleOptions = 0;
    const {
      dateFormat,
      version,
      entityThesauris,
      attachments,
      localAttachments,
      multipleEdition,
      locale,
      model
    } = this.props;
    const propertyType = property.type;
    const plainAttachments = attachments.toJS();
    const plainLocalAttachments = localAttachments;
    const isPublicForm = model === 'publicform';

    switch (propertyType) {
      case 'select':
        thesauri = thesauris.find((opt) => opt.get('_id').toString() === property.content.toString());
        return (/*#__PURE__*/
          React.createElement(React.Fragment, null,
          !isPublicForm && /*#__PURE__*/
          _jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
          _jsx(AddThesauriValueButton, {
            values: translateOptions(thesauri),
            onModalAccept: async (newValue) => {
              await this.onAddThesauriValueSaved(thesauri, newValue, _model, false);
            } }
          )
          ), /*#__PURE__*/

          _jsx(Select, {
            model: _model,
            optionsValue: "id",
            options: translateOptions(thesauri),
            placeholder: "Select..." }
          )
          ));

      case 'multiselect':
        thesauri = thesauris.find((opt) => opt.get('_id').toString() === property.content.toString());
        return (/*#__PURE__*/
          React.createElement(React.Fragment, null,
          !isPublicForm && /*#__PURE__*/
          _jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
          _jsx(AddThesauriValueButton, {
            values: translateOptions(thesauri),
            onModalAccept: async (newValue) => {
              await this.onAddThesauriValueSaved(thesauri, newValue, _model, true);
            } }
          )
          ), /*#__PURE__*/

          _jsx(MultiSelect, {
            model: _model,
            optionsValue: "id",
            options: translateOptions(thesauri),
            prefix: _model,
            forceHoist: version === 'OneUp',
            placeholder:
            version === 'OneUp' ?
            `${t('System', 'Search', null, false)} '${thesauri.get('name')}'` :
            null }

          )
          ));

      case 'relationship':
        if (property.content) {
          const source = thesauris.find(
            (opt) => opt.get('_id').toString() === property.content.toString()
          );

          totalPossibleOptions = source.get('optionsCount');
          thesauri = translateOptions(source);
        }

        if (!property.content) {
          thesauri = Array.prototype.
          concat(
            ...thesauris.
            filter((filterThesauri) => filterThesauri.get('type') === 'template').
            map((source) => {
              totalPossibleOptions += source.get('optionsCount');
              return translateOptions(source);
            })
          ).
          slice(0, preloadOptionsLimit());
        }

        if (entityThesauris.get(property.name)) {
          entityThesauris.
          get(property.name).
          toJS().
          forEach((o) => {
            thesauri.push({ id: o.value, label: o.label });
          });
        }

        return (/*#__PURE__*/
          _jsx(LookupMultiSelect, {
            lookup: getSuggestions.bind(null, property.content ? [property.content] : []),
            model: _model,
            optionsValue: "id",
            options: thesauri,
            totalPossibleOptions: totalPossibleOptions,
            prefix: _model,
            onChange: this.relationshipChange.bind(this, property),
            sort: true }
          ));

      case 'newRelationship':
        if (!property.targetTemplates) {
          return null;
        }

        if (property.targetTemplates.length > 0) {
          thesauri = Array.prototype.
          concat(
            ...thesauris.
            filter((opt) => property.targetTemplates.includes(opt.get('_id').toString())).
            map((source) => {
              totalPossibleOptions += source.get('optionsCount');
              return translateOptions(source);
            })
          ).
          slice(0, preloadOptionsLimit());
        }

        if (property.targetTemplates.length === 0) {
          thesauri = Array.prototype.
          concat(
            ...thesauris.
            filter((filterThesauri) => filterThesauri.get('type') === 'template').
            map((source) => {
              totalPossibleOptions += source.get('optionsCount');
              return translateOptions(source);
            })
          ).
          slice(0, preloadOptionsLimit());
        }

        if (entityThesauris.get(property.name)) {
          entityThesauris.
          get(property.name).
          toJS().
          forEach((o) => {
            thesauri.push({ id: o.value, label: o.label });
          });
        }

        return (/*#__PURE__*/
          _jsx(LookupMultiSelect, {
            lookup: getSuggestions.bind(null, property.content ? [property.content] : []),
            model: _model,
            optionsValue: "id",
            options: thesauri,
            totalPossibleOptions: totalPossibleOptions,
            prefix: _model,
            onChange: this.relationshipChange.bind(this, property),
            sort: true }
          ));

      case 'date':
        return /*#__PURE__*/_jsx(DatePicker, { model: _model, format: dateFormat, locale: locale });
      case 'daterange':
        return /*#__PURE__*/_jsx(DateRange, { model: _model, format: dateFormat, locale: locale });
      case 'numeric':
        return /*#__PURE__*/_jsx(Numeric, { model: _model });
      case 'markdown':
        return /*#__PURE__*/_jsx(MarkDown, { model: _model });
      case 'nested':
        return /*#__PURE__*/_jsx(Nested, { model: _model });
      case 'multidate':
        return /*#__PURE__*/_jsx(MultiDate, { model: _model, format: dateFormat, locale: locale });
      case 'multidaterange':
        return /*#__PURE__*/_jsx(MultiDateRange, { model: _model, format: dateFormat, locale: locale });
      case 'geolocation':
        return /*#__PURE__*/_jsx(Geolocation, { model: _model });
      case 'link':
        return /*#__PURE__*/_jsx(LinkField, { model: _model });
      case 'media':
        return (/*#__PURE__*/
          _jsx(MediaField, {
            model: _model,
            formModel: formModel,
            attachments: plainAttachments,
            localAttachments: plainLocalAttachments,
            type: MediaModalType.Media,
            multipleEdition: multipleEdition }
          ));

      case 'image':
        return (/*#__PURE__*/
          _jsx(MediaField, {
            model: _model,
            formModel: formModel,
            attachments: plainAttachments,
            localAttachments: plainLocalAttachments,
            type: MediaModalType.Image,
            multipleEdition: multipleEdition }
          ));

      case 'preview':
        return (/*#__PURE__*/
          _jsx("div", {}, void 0, /*#__PURE__*/
          _jsx("em", {}, void 0, /*#__PURE__*/
          _jsx(Translate, {}, void 0, "This content is automatically generated")
          )
          ));

      case 'generatedid':
        return (/*#__PURE__*/
          _jsx(Field, { model: _model }, void 0, /*#__PURE__*/
          _jsx("input", {
            type: "text",
            className: "form-control",
            defaultValue: formModel === 'publicform' ? generateID(3, 4, 4) : undefined }
          )
          ));

      case 'text':
        return (/*#__PURE__*/
          _jsx(Field, { model: _model }, void 0, /*#__PURE__*/
          _jsx("input", { type: "text", className: "form-control" })
          ));

      default:
        return false;
    }
  }

  relationshipChange(prop, value) {var _prop$multiEditingRel;
    const { change, model } = this.props;
    (_prop$multiEditingRel = prop.multiEditingRelationshipFields) === null || _prop$multiEditingRel === void 0 ? void 0 : _prop$multiEditingRel.forEach((p) => {
      change(`${model}.metadata.${p.name}`, value);
    });
  }

  renderLabel(property) {
    const { template, multipleEdition, model } = this.props;
    const templateID = template.get('_id');
    let label = templateID ? /*#__PURE__*/
    _jsx(Translate, { context: templateID }, void 0, property.label) :

    property.label;


    if (property.multiEditingRelationshipFields) {
      label = /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, { context: templateID }, void 0, property.label), "\xA0(", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Multiple inherited properties warning ([property 1] affects [property 2])"

      ), "\xA0",

      property.multiEditingRelationshipFields.map((p) => /*#__PURE__*/
      _jsx("span", {}, p._id, "\"", /*#__PURE__*/
      _jsx(Translate, { context: templateID }, void 0, p.label), "\"\xA0"
      )
      ), ")", /*#__PURE__*/

      _jsx(Tip, { icon: "info-circle", position: "left" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Multiple relationships edit description" }, void 0, "Making changes to this property will affect other properties on this template because they all share relationships with the same configuration."


      )
      )
      )
      );

    }

    return (/*#__PURE__*/
      _jsx("li", { className: "title" }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(MultipleEditionFieldWarning, {
        multipleEdition: multipleEdition,
        model: model,
        field: `metadata.${property.name}` }
      ),
      label,
      property.required ? /*#__PURE__*/_jsx("span", { className: "required" }, void 0, "*") : ''
      )
      ));

  }

  render() {
    const { thesauris, template, model, showSubset, storeKey, pdfLanguage, locale } = this.props;

    const mlThesauri = thesauris.
    filter((thes) => !!thes.get('enable_classification')).
    map((thes) => thes.get('_id')).
    toJS();
    const fields = groupSameRelationshipFields(template.get('properties').toJS());
    return (/*#__PURE__*/
      _jsx("div", {}, void 0,
      fields.
      filter((p) => !showSubset || showSubset.includes(p.name)).
      map((property) => {
        const showIXButtons =
        storeKey === 'documentViewer' &&
        ['text', 'date', 'numeric', 'markdown'].includes(property.type);
        return (/*#__PURE__*/
          _jsx(FormGroup, {

            model: `.metadata.${property.name}`,
            className:
            model === 'publicform' && property.type === 'generatedid' ?
            ' hidden ' :
            property.type }, property.name, /*#__PURE__*/


          _jsx("ul", {
            className: `search__filter is-active ${
            this.props.highlightedProps.includes(property.name) ? 'highlight' : ''}` }, void 0,


          this.renderLabel(property),
          mlThesauri.includes(property.content) &&
          [propertyTypes.multiselect, propertyTypes.select].includes(property.type) ? /*#__PURE__*/
          _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
          _jsx(MultiSuggest, {
            model: `.suggestedMetadata.${property.name}`,
            selectModel: `.metadata.${property.name}`,
            propertyType: property.type }
          )
          ) :
          null, /*#__PURE__*/
          _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
          _jsx("div", { className: "metadata-extractor-container" }, void 0,
          showIXButtons && /*#__PURE__*/
          _jsx(MetadataExtractor, {
            fieldName: property.name,
            fieldId: property._id,
            fieldType: property.type,
            model: `${model}.metadata.${property.name}`,
            locale: pdfLanguage || locale }
          ),

          this.getField(property, `.metadata.${property.name}`, thesauris, model)
          )
          ),
          showIXButtons && /*#__PURE__*/
          _jsx(DeleteSelectionButton, { propertyName: property.name, propertyID: property._id })

          )
          ));

      })
      ));

  }
}

MetadataFormFields.defaultProps = {
  saveThesaurus: () => {},
  push: () => {},
  multipleEdition: false,
  dateFormat: null,
  version: undefined,
  showSubset: undefined,
  entityThesauris: Immutable.fromJS({}),
  attachments: Immutable.fromJS([]),
  highlightedProps: [],
  localAttachments: [],
  storeKey: '',
  locale: '',
  pdfLanguage: ''
};





















export const mapStateToProps = (state, ownProps) => {
  const { storeKey } = ownProps;

  let attachments = Immutable.fromJS([]);
  let localAttachments;
  let pdfLanguage;

  if (storeKey === 'library') {
    const selectedDocuments = state.library.ui.get('selectedDocuments');
    attachments = selectedDocuments.size ? selectedDocuments.get(0).get('attachments') : undefined;
    localAttachments = state.library.sidepanel.metadata.attachments;
  }

  if (storeKey === 'documentViewer') {var _entity$get;
    const entity = state[storeKey].doc;
    pdfLanguage = (_entity$get = entity.get('defaultDoc')) === null || _entity$get === void 0 ? void 0 : _entity$get.get('language');
    attachments = entity.get('attachments');
    localAttachments = state[storeKey].sidepanel.metadata.attachments;
  }

  if (!storeKey) {
    const { entity } = state.entityView;
    attachments = entity.get('attachments');
    localAttachments = state.entityView.entityForm.attachments;
  }

  const { locale } = state;
  return {
    dateFormat: state.settings.collection.get('dateFormat'),
    entityThesauris: state.entityThesauris,
    attachments,
    localAttachments,
    locale,
    pdfLanguage
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  if (ownProps.boundChange) {
    return { change: ownProps.boundChange };
  }
  return bindActionCreators(
    { saveThesaurus, change: formActions.change, push: formActions.push },
    dispatch
  );
};

export { MetadataFormFields, translateOptions };
export default connect(mapStateToProps, mapDispatchToProps)(MetadataFormFields);